import { render } from "./Resume.vue?vue&type=template&id=33d7e338"
import script from "./Resume.vue?vue&type=script&lang=js"
export * from "./Resume.vue?vue&type=script&lang=js"

import "./Resume.vue?vue&type=style&index=0&id=33d7e338&lang=scss"

import exportComponent from "/Users/pamelamontanez/Documents/projects/personal-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__